var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRewardShopoutloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 998.56 998.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #333;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 48px;\n      }\n\n      .cls-7 {\n        filter: url(#drop-shadow-11);\n      }\n\n      .cls-2 {\n        fill: #96d6d6;\n      }\n\n      .cls-3 {\n        fill: #ae76cc;\n      }\n\n      .cls-4 {\n        fill: #ffc557;\n      }\n\n      .cls-5 {\n        fill: #cfd9ff;\n      }\n\n      .cls-8 {\n        fill: #333;\n      }\n\n      .cls-6 {\n        fill: #75cc81;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-11",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 499.28,
    cy: 499.28,
    r: 475.28
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 619.48,
    y: 350.24,
    width: 177.92,
    height: 254.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 691.1,
    y: 499.28,
    width: 177.92,
    height: 177.92
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 135.73,
    y: 422.52,
    width: 177.92,
    height: 254.68
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "744.25 770.38 254.32 770.38 293.68 286.57 704.88 286.57 744.25 770.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M499.28,133.39h0c48.63,0,88.11,39.48,88.11,88.11v65.07h-176.23v-65.07c0-48.63,39.48-88.11,88.11-88.11Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M959.32,304.93c-25.15-59.46-61.15-112.85-106.99-158.7s-99.24-81.84-158.7-106.99C632.06,13.2,566.67,0,499.28,0s-132.78,13.2-194.35,39.25c-59.46,25.15-112.85,61.14-158.7,106.99s-81.84,99.24-106.99,158.7C13.2,366.5,0,431.89,0,499.28s13.2,132.78,39.25,194.35c25.15,59.46,61.15,112.85,106.99,158.7s99.24,81.84,158.7,106.99c61.57,26.04,126.96,39.25,194.35,39.25s132.78-13.2,194.35-39.25c59.46-25.15,112.85-61.14,158.7-106.99s81.84-99.24,106.99-158.7c26.04-61.57,39.25-126.96,39.25-194.35s-13.2-132.78-39.25-194.35ZM915.11,674.93c-22.73,53.74-55.27,102-96.72,143.45-41.45,41.45-89.72,74-143.45,96.72-55.62,23.53-114.72,35.45-175.65,35.45s-120.03-11.93-175.65-35.45c-53.74-22.73-102-55.27-143.45-96.72-41.45-41.45-74-89.72-96.72-143.45-23.53-55.62-35.45-114.72-35.45-175.65s11.93-120.03,35.45-175.65c22.73-53.74,55.27-102,96.72-143.45,41.45-41.45,89.72-74,143.45-96.72,55.62-23.53,114.72-35.45,175.65-35.45s120.03,11.93,175.65,35.45c53.74,22.73,102,55.27,143.45,96.72,41.45,41.45,74,89.72,96.72,143.45,23.53,55.62,35.45,114.72,35.45,175.65s-11.93,120.03-35.45,175.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M869.02,475.28h-47.62v-125.04c0-13.25-10.75-24-24-24h-65.21l-3.39-41.61c-1.01-12.46-11.42-22.05-23.92-22.05h-93.48v-41.07c0-61.82-50.29-112.11-112.11-112.11h0c-61.82,0-112.11,50.29-112.11,112.11v41.07h-93.48c-12.5,0-22.91,9.59-23.92,22.05l-9.27,113.89h-124.77c-13.25,0-24,10.75-24,24v254.68c0,13.25,10.75,24,24,24h100.14l-5.47,67.23c-.54,6.68,1.73,13.29,6.28,18.21,4.54,4.93,10.94,7.73,17.65,7.73h489.93c6.7,0,13.1-2.8,17.65-7.73,4.54-4.93,6.82-11.53,6.28-18.21l-5.47-67.23h106.32c13.25,0,24-10.75,24-24v-177.92c0-13.25-10.75-24-24-24ZM773.4,374.24v101.04h-29.08l-8.22-101.04h37.31ZM435.17,221.5c0-35.35,28.76-64.11,64.11-64.11s64.11,28.76,64.11,64.11v41.07h-128.23v-41.07ZM159.73,653.2v-206.68h96.86l-16.82,206.68h-80.04ZM280.35,746.38l35.46-435.8h366.95l35.46,435.8h-437.87ZM845.02,653.2h-86.22l-10.57-129.92h96.8v129.92Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRewardShopoutloud);
export default __webpack_public_path__ + "static/media/icon-reward-shopoutloud.6c50ff155aa13f2e7914b4238be151d1.svg";
export { ForwardRef as ReactComponent };